import type { AddressData } from '../types';
import { formatTableData } from '../utils/formatters';

const SPRINGDALE_ROWS = [
  {
    label: 'Address',
    getValue: (data: AddressData) => data?.address || 'No address information available'
  },
  {
    label: 'Zone',
    getValue: (data: AddressData) => data?.zone || 'No zone information available'
  },
  {
    label: 'Ward / City Council',
    getValue: (data: AddressData) => {
      if (data?.wards?.ward || data?.wards?.position1 || data?.wards?.position2) {
        return `Ward: ${data?.wards?.ward || 'N/A'} represented by ${data?.wards?.position1 || 'N/A'}, ${
          data?.wards?.position2 || 'N/A'
        }`;
      }
      return 'No ward information available';
    }
  },
  {
    label: 'Utility Providers',
    getValue: (data: AddressData) => {
      if (
        data?.natural_gas_provider?.name ||
        data?.water_provider?.name ||
        data?.electric_service_provider?.name ||
        data?.telephone_service_provider?.name
      ) {
        return `**Gas:** ${data?.natural_gas_provider?.name || 'N/A'}, **Water:** ${
          data?.water_provider?.name || 'N/A'
        }, **Electric:** ${data?.electric_service_provider?.name || 'N/A'}, **Telephone:** ${
          data?.telephone_service_provider?.name || 'N/A'
        }`;
      }
      return 'No utility provider information available';
    }
  },
  {
    label: 'Election Precinct',
    getValue: (data: AddressData) => {
      if (data?.election_precincts?.county_name || data?.election_precincts?.precinct) {
        return `${data?.election_precincts?.county_name || 'N/A'} County, ${data?.election_precincts?.precinct || 'N/A'}`;
      }
      return 'No election precinct information available';
    }
  },
  {
    label: 'School Board Zone',
    getValue: (data: AddressData) => {
      if (data?.springdale_school_board_zones?.zone || data?.springdale_school_board_zones?.zone_member) {
        return `Zone: ${data?.springdale_school_board_zones?.zone || 'N/A'}, Zone Representative: ${
          data?.springdale_school_board_zones?.zone_member || 'N/A'
        }`;
      }
      return 'No school board information available';
    }
  },
  {
    label: 'Arkansas House District',
    getValue: (data: AddressData) => {
      if (
        data?.arkansas_house_districts?.district ||
        data?.arkansas_house_districts?.name ||
        data?.arkansas_house_districts?.party
      ) {
        return `District: ${data?.arkansas_house_districts?.district || 'N/A'} Representative: ${
          data?.arkansas_house_districts?.name || 'N/A'
        }, ${data?.arkansas_house_districts?.party || 'N/A'}`;
      }
      return 'No Arkansas House District information available';
    }
  },
  {
    label: 'Arkansas Senate District',
    getValue: (data: AddressData) => {
      if (
        data?.arkansas_senate_districts?.district ||
        data?.arkansas_senate_districts?.name ||
        data?.arkansas_senate_districts?.party
      ) {
        return `District: ${data?.arkansas_senate_districts?.district || 'N/A'} Senator: ${
          data?.arkansas_senate_districts?.name || 'N/A'
        }, ${data?.arkansas_senate_districts?.party || 'N/A'}`;
      }
      return 'No Arkansas Senate District information available';
    }
  },
  {
    label: 'School Attendance Zones',
    getValue: (data: AddressData) => {
      if (
        data?.springdale_school_district_attendance_zone_2023?.elementary ||
        data?.springdale_school_district_attendance_zone_2023?.middle ||
        data?.springdale_school_district_attendance_zone_2023?.junior_high ||
        data?.springdale_school_district_attendance_zone_2023?.high
      ) {
        return `${data?.springdale_school_district_attendance_zone_2023?.elementary || 'N/A'} Elementary, ${
          data?.springdale_school_district_attendance_zone_2023?.middle || 'N/A'
        } Middle, ${data?.springdale_school_district_attendance_zone_2023?.junior_high || 'N/A'} Junior High, ${
          data?.springdale_school_district_attendance_zone_2023?.high || 'N/A'
        } High`;
      }
      return 'No school zone information available';
    }
  },
  {
    label: 'GIS Map',
    getValue: (data: AddressData) => {
      if (data?.map) {
        return `[View in GIS](${data?.map})`;
      }
      return 'No GIS map available';
    }
  }
];

export const formatSpringdaleData = (data: AddressData): string => {
  return formatTableData(data, SPRINGDALE_ROWS);
}; 